import { useParams } from 'react-router-dom';
import BusinessPageClient from '@/components/booking/BusinessPageClient';

export default function BusinessPage() {
  const { businessId } = useParams<{ businessId: string }>();
  
  return (
    <div suppressHydrationWarning>
      <BusinessPageClient businessId={businessId!} />
    </div>
  );
}